export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/dThree.1d85bbc.svg";